import { render, staticRenderFns } from "./BasicInformation.vue?vue&type=template&id=d8ff9fdc&scoped=true&"
import script from "./BasicInformation.vue?vue&type=script&lang=js&"
export * from "./BasicInformation.vue?vue&type=script&lang=js&"
import style0 from "./BasicInformation.vue?vue&type=style&index=0&id=d8ff9fdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ff9fdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8ff9fdc')) {
      api.createRecord('d8ff9fdc', component.options)
    } else {
      api.reload('d8ff9fdc', component.options)
    }
    module.hot.accept("./BasicInformation.vue?vue&type=template&id=d8ff9fdc&scoped=true&", function () {
      api.rerender('d8ff9fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/terminalActivity/components/BasicInformation.vue"
export default component.exports